import React from 'react';
import { Box, Typography } from '@mui/material';

interface ItemHelpContentProps {
  language: string;
  canManage: boolean;
  isSuperAdmin: boolean;
}

export const ItemHelpContent: React.FC<ItemHelpContentProps> = ({ language, canManage, isSuperAdmin }) => language === 'tr' ? (
  <Box>
    <Typography variant="body2" paragraph><strong>Ürün kataloğunu arayın ve envanter bilgilerini inceleyin.</strong></Typography>
    <Typography variant="subtitle2" gutterBottom>🔍 <strong>Arama ve Filtreleme:</strong></Typography>
    <Typography variant="body2" paragraph>
      • Ürünleri ada göre arayın<br/>
      • Filtreler’i kullanarak fiyat veya kategori seçin<br/>
      • Tabloda gösterilen sütunları özelleştirmek için Sütunlar düğmesini kullanın
    </Typography>
    <Typography variant="subtitle2" gutterBottom>📦 <strong>Envanter:</strong></Typography>
    <Typography variant="body2" paragraph>
      • Envanter görünümünü açarak stok, varsa parti listesi ve işlem geçmişini inceleyin<br/>
      {canManage
        ? <>• Stok Ekle, Stok Çıkar veya Stok Ayarla işlemlerini kullanın<br/>• Parti takibini yalnızca Süper Yöneticiler ve Şirket Yöneticileri değiştirebilir</>
        : '• Çalışan hesaplarında envanter bilgileri görüntülenir; stok değiştirme kontrolleri gösterilmez'}
    </Typography>
    {canManage && !isSuperAdmin ? <>
      <Typography variant="subtitle2" gutterBottom>➕ <strong>Ürün Ekleme:</strong></Typography>
      <Typography variant="body2" paragraph>
        • Ürün Ekle ile Ürün veya Hizmet türünü seçin; ürünlerde fiyat ve başlangıç stoğu zorunludur<br/>
        • Toplu Yükleme için CSV şablonunu kullanın; aktarılan ürünlerin stoğu sıfır başlar<br/>
        • Kategori Yönetimi’nden kategori oluşturup ürünlere atayın
      </Typography>
      <Typography variant="subtitle2" gutterBottom>✏️ <strong>Düzenleme:</strong></Typography>
      <Typography variant="body2" paragraph>
        • Satır işlemlerinden ürün bilgisini düzenleyin veya ürünü silin<br/>
        • Ürün fiyatını değiştirmek mevcut parti fiyatlarını değiştirmez
      </Typography>
    </> : isSuperAdmin ? <>
      <Typography variant="subtitle2" gutterBottom>➕ <strong>Ürün Aktarma ve Yönetimi:</strong></Typography>
      <Typography variant="body2" paragraph>
        • Toplu Yükleme’de CSV şablonunu kullanıp hedef şirketi seçin; aktarılan ürünlerin stoğu sıfır başlar<br/>
        • Mevcut tek ürün ve kategori oluşturma formlarında şirket seçimi yoktur<br/>
        • Satır işlemlerinden mevcut ürünleri düzenleyin veya silin<br/>
        • Ürün fiyatını değiştirmek mevcut parti fiyatlarını değiştirmez
      </Typography>
    </> : null}
    <Typography variant="subtitle2" gutterBottom>💡 <strong>İpuçları:</strong></Typography>
    <Typography variant="body2">
      • Stoksuz ürünler stok takibi yapılmadığını gösterir<br/>
      • Düşük stok uyarı rengiyle, stoksuz ürünler kırmızıyla gösterilir
    </Typography>
  </Box>
) : (
  <Box>
    <Typography variant="body2" paragraph><strong>Search the item catalog and review inventory information.</strong></Typography>
    <Typography variant="subtitle2" gutterBottom>🔍 <strong>Search and Filtering:</strong></Typography>
    <Typography variant="body2" paragraph>
      • Search items by name<br/>
      • Use Filters to choose a price range or category<br/>
      • Use the Columns button to customize which columns appear in the table
    </Typography>
    <Typography variant="subtitle2" gutterBottom>📦 <strong>Inventory:</strong></Typography>
    <Typography variant="body2" paragraph>
      • Open the inventory view to review stock, batches when enabled, and transaction history<br/>
      {canManage
        ? <>• Use Add Stock, Remove Stock, or Adjust Stock<br/>• Only Super Administrators and Company Administrators can change batch tracking settings</>
        : '• Employee accounts can view inventory information; stock change controls are not shown'}
    </Typography>
    {canManage && !isSuperAdmin ? <>
      <Typography variant="subtitle2" gutterBottom>➕ <strong>Adding Items:</strong></Typography>
      <Typography variant="body2" paragraph>
        • Choose Add Item and select Product or Service; products require a price and starting stock<br/>
        • Use the CSV template for Bulk Upload; imported items start with zero stock<br/>
        • Create categories with Manage Categories and assign them to items
      </Typography>
      <Typography variant="subtitle2" gutterBottom>✏️ <strong>Editing:</strong></Typography>
      <Typography variant="body2" paragraph>
        • Use row actions to edit or delete an item<br/>
        • Changing an item price does not change existing batch prices
      </Typography>
    </> : isSuperAdmin ? <>
      <Typography variant="subtitle2" gutterBottom>➕ <strong>Importing and Managing Items:</strong></Typography>
      <Typography variant="body2" paragraph>
        • Use the CSV template in Bulk Upload and select the target company; imported items start with zero stock<br/>
        • The current single-item and category creation forms have no company selector<br/>
        • Use row actions to edit or delete existing items<br/>
        • Changing an item price does not change existing batch prices
      </Typography>
    </> : null}
    <Typography variant="subtitle2" gutterBottom>💡 <strong>Tips:</strong></Typography>
    <Typography variant="body2">
      • Non-stock items indicate that inventory is not tracked<br/>
      • Low stock uses a warning color; out-of-stock items are shown in red
    </Typography>
  </Box>
);
